exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-original[data-v-185a125b] {\n  text-decoration: line-through;\n  font-size: 18px;\n}\n.office-price-color[data-v-185a125b] {\n  color: #7FB8C8;\n}\n@media (max-width: 767px) {\n.price[data-v-185a125b] {\n    color: #707070;\n}\n}\n", ""]);

// exports
